/**
 * Short-window dedupe for back-to-back duplicate excel-files-metadata fetches
 * (parent OrganisationDetails effect + transactions-tab fallback). The single
 * source of truth for "metadata is loaded" lives on the organisation object
 * (`excelFilesMetadata !== undefined` after a successful fetch), so we
 * intentionally do NOT keep a persistent "initial requested" flag here — that
 * caused refresh-time fetches whose responses landed before `organisations`
 * hydrated to be silently lost (the reducer can't merge into an undefined org
 * list) while still blocking all future retries.
 */
const excelFilesMetadataBurstAt = new Map<string, number>();

export function shouldSkipExcelFilesMetadataBurst(
  organisationId: string,
  windowMs = 1500
): boolean {
  const now = Date.now();
  const lastAt = excelFilesMetadataBurstAt.get(organisationId);
  if (lastAt != null && now - lastAt < windowMs) return true;
  excelFilesMetadataBurstAt.set(organisationId, now);
  if (excelFilesMetadataBurstAt.size > 200) {
    for (const [key, at] of excelFilesMetadataBurstAt.entries()) {
      if (now - at > windowMs * 10) excelFilesMetadataBurstAt.delete(key);
    }
  }
  return false;
}
